<script setup>
import {computed, onMounted, ref} from "vue";
import needsDashboardService from "@/services/needs-dashboard.service";

const activities = ref([]);
const page = ref(1);

const displayedActivities = computed(() => activities.value.slice(0, page.value * 5));
const hasMore = computed(() => activities.value.length > displayedActivities.value.length);

onMounted(() => {
    getActivities();
})

async function getActivities() {
    const {data} = await needsDashboardService.getActivities();
    activities.value = data;
}
</script>

<template>
    <div v-if="activities.length" class="need-admin__plate">
        <header class="need-admin__plate__header">
            <h6 class="heading6 heading6--activity">User Activity</h6>
        </header>

        <div class="need-admin__plate__content">
            <ul class="need-admin__activity">
                <li
                    v-for="(activity, index) in displayedActivities"
                    :key="index"
                    :class="{
                        'need-admin__activity__edit': activity.action === 'created',
                        'need-admin__activity__export': activity.action === 'escalated',
                    }"
                >
                    <div>
                        <h6 class="heading6">{{activity.user_name}} <template v-if="activity.user_deleted">(D)</template> {{ activity.action }}</h6>
                        <p><a :href="`/needs/${activity.id}`" target="_blank">{{activity.name}}</a></p>
                    </div>
                    <time class="need-admin__activity__time">{{activity.period}}</time>
                </li>
            </ul>

            <div v-if="hasMore" class="text-center mt-3">
                <a @click="page++" class="link">Load More</a>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
